import AccountCardPrint from './AccountCardPrint';

export default AccountCardPrint;
